'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _reactTicker = require('react-ticker');

var _reactTicker2 = _interopRequireDefault(_reactTicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ticker = function Ticker(_ref) {
  var classNames = _ref.classNames,
      direction = _ref.direction,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      label = _ref.label,
      mode = _ref.mode,
      offset = _ref.offset,
      pauseOnHover = _ref.pauseOnHover,
      speed = _ref.speed;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      move = _useState2[0],
      setMove = _useState2[1];

  var speeds = {
    snail: 5,
    slow: 7.5,
    medium: 10,
    fast: 12.5,
    cheetah: 20
  };

  return _react2.default.createElement(
    'div',
    {
      className: 'c11n-ticker ' + classNames.root,
      onMouseOver: function onMouseOver() {
        return pauseOnHover && setMove(false);
      },
      onMouseLeave: function onMouseLeave() {
        return setMove(true);
      }
    },
    _react2.default.createElement(
      _reactTicker2.default,
      {
        direction: direction,
        mode: mode,
        move: move,
        offset: offset,
        speed: speeds[speed]
      },
      function () {
        return _react2.default.createElement(
          'ul',
          { className: classNames.items },
          items.map(function (item, index) {
            return _react2.default.createElement(
              'li',
              { className: classNames.item, key: index },
              item
            );
          })
        );
      }
    ),
    label && _react2.default.createElement(
      'div',
      { className: classNames.label },
      label
    )
  );
};

Ticker.propTypes = {
  /**
   * The background color
   */
  background: _propTypes2.default.string,

  /**
   * The color of the text
   */
  foreground: _propTypes2.default.string,

  /**
   * The scrolling direction
   */
  direction: _propTypes2.default.oneOf(['toLeft', 'toRight']),

  /**
   * The height (passed to rhythm)
   */
  height: _propTypes2.default.number,

  /**
   * Items to display in animated scroll
   */
  items: _propTypes2.default.array.isRequired,

  /**
   * The label text
   */
  label: _propTypes2.default.string,

  /**
   * The label background color
   */
  labelBackground: _propTypes2.default.string,

  /**
   * The color of the label text
   */
  labelForeground: _propTypes2.default.string,

  /**
   * The mode for the ticker
   */
  mode: _propTypes2.default.oneOf(['await', 'chain', 'smooth']),

  /**
   * Ticker offset
   */
  offset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Pause ticker on hover?
   */
  pauseOnHover: _propTypes2.default.bool,

  /**
   * Animation speed
   */
  speed: _propTypes2.default.oneOf(['snail', 'slow', 'medium', 'fast', 'cheetah']),

  /**
   * Custom styles to be applied
   */
  styles: _propTypes2.default.object
};

Ticker.defaultProps = {
  background: 'shade',
  foreground: 'dark',
  direction: 'toLeft',
  height: 2.5,
  labelBackground: 'primary',
  labelForeground: 'light',
  mode: 'smooth',
  offset: '100%',
  pauseOnHover: true,
  speed: 'slow',
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(Ticker);